module.exports = __webpack_public_path__ + "img/img-1.45a03bca.png";